// MenuIcon.js
import { mvs } from 'react-native-size-matters';

import { CustomIcon } from './CustomIcon';
import i18n from '../localization/i18n';

interface MenuIconProps {
  color: string;
  toggleLeftDrawer: () => void;
}

export function MenuIcon({ color, toggleLeftDrawer }: MenuIconProps) {
  return (
    <CustomIcon
      name="menu"
      color={color}
      size={mvs(24)}
      onPress={toggleLeftDrawer}
      accessibilityLabel={i18n.t('accessibility.menu')}
      accessibilityRole="button"
    />
  );
}
